import { render } from "./ContactTab.vue?vue&type=template&id=043c0e84"
import script from "./ContactTab.vue?vue&type=script&lang=js"
export * from "./ContactTab.vue?vue&type=script&lang=js"

import "./ContactTab.vue?vue&type=style&index=0&id=043c0e84&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__